<div class="planning-time-entry-layout">

  <app-time-entry-header
    [title]="'TIME ENTRY - PLAN'"
    [isDeleteDisabled]="selectedEntryIds.length === 0"
     [isSaveDisabled]="isSaveDisabled || isSaving"
    [(view)]="viewMode"
    (newClicked)="openAddPlanDialog()"
    (saveClicked)="savePlanningEntries()"
    (deleteClicked)="deleteSelectedPlans()"
    (resetClicked)="resetPlanningEntries()">
  </app-time-entry-header>

  <div class="planning-time-entry-content">

    <!-- Left panel -->
    <div class="entry-panel-column" [class.is-collapsed]="filterFullyCollapsed">

      <app-plan-filter-panel
        [collapsedSummary]="showEntryPanel"
        (collapsedChange)="filterFullyCollapsed = $event">
      </app-plan-filter-panel>

      <app-add-plan-dialog
        *ngIf="showEntryPanel"
        [data]="entryPanelData"
        (result)="onEntryPanelResult($event)"
        (cancelled)="onEntryPanelCancelled()">
      </app-add-plan-dialog>

    </div>

    <!-- Right / table region -->
    <div
      class="planning-entry-table-region"
      [class.planning-entry-table-region--wide]="showEntryPanel"
    >

      <!-- Summary bar -->
      <section
        class="planning-summary-bar"
        aria-label="Planning entry summary"
      >

        <div class="flex items-center gap-3 min-w-0">

          <span class="summary-total-hours">
            Total Hours = {{ totalHours | number:'1.2-2' }}
          </span>

          <span class="summary-row-count">
            {{ rowCount }} rows
          </span>

          <div
            class="clash-chip"
            [class.clash-chip--active]="clashFilterActive"
            *ngIf="showClashCount && clashCount > 0"
          >
            <mat-icon>error_outline</mat-icon>
            <span>{{ clashCount }} clashes</span>
          </div>

        </div>

      </section>

      <!-- Planning table / calendar -->
      <app-planning-entry-table
        *ngIf="viewMode === 'grid'"
        [entries]="planningEntries"
        [loggedInUsername]="loggedInUsername"
        (entriesChanged)="onEntriesChanged($event)"
        (selectionChanged)="updateSelection($event)"
        (editEntryRequested)="onEditEntryRequested($event)"
        (filteredEntriesChanged)="onFilteredEntriesChanged($event)">
      </app-planning-entry-table>

      <app-plan-calendar-view
        *ngIf="viewMode === 'calendar'"
        [entries]="planningEntries"
        (filteredEntriesChanged)="onFilteredEntriesChanged($event)">
      </app-plan-calendar-view>

    </div>

  </div>

</div>